export default "__VITE_ASSET___Lab99aW__"